import { useMemo, useState } from "react";

// Identification lasts only the current sale/session: state lives in memory
// (no localStorage) and is cleared explicitly via resetLoyalty() on a new sale.
// The shopper can only be identified in one loyalty program at a time — identifying
// into a new one replaces whichever was active, it never accumulates.
export function useLoyalty(env, client) {
  const [identifiedPrograms, setIdentifiedPrograms] = useState({});

  const identify = async (programId, identifiers) => {
    const url = `https://identifyloyaltyprogram-x3herayjcq-uc.a.run.app?environment=${env}&client=${client}`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ program_id: programId, identifiers }),
    });

    const data = await response.json();

    if (data.success) {
      setIdentifiedPrograms({ [programId]: data });
    }

    return data;
  };

  const resetLoyalty = () => setIdentifiedPrograms({});

  // What travels with the cart. The UI works with a map keyed by program because a
  // shopper could belong to several, but a sale is always attributed to the single
  // program they identified into, so the cart carries one flat reference. It stays a
  // reference on purpose — the rut and any other identifier are read from
  // loyalty_members, so they are never copied into every cart.
  // tier_id is the exception: it is frozen here because the record has to say what the
  // member was worth at the time of the sale, not what they are worth when read back.
  const identifiedMember = useMemo(() => {
    const identified = Object.values(identifiedPrograms)[0];
    if (!identified?.member_id) return null;

    return {
      program_id: identified.program_id,
      member_id: identified.member_id,
      tier_id: identified.membership?.tier_id ?? null,
    };
  }, [identifiedPrograms]);

  return { identifiedPrograms, identifiedMember, identify, resetLoyalty };
}
